import { Injectable, Inject } from '@angular/core';

const MainServiceEndPoints = {
  VALIDATE_TOKEN: '/activation/tenantapps',
  GET_APPSFOR_TENAN: 'GET_APPSFOR_TENAN',
  GET_APP_MASTER: '/activation/appmaster',
  ACTIVATE_APP: '/activation/activateapp',
  CLIENT_PROFILE_ACK: '/activation/agentack',
  SUPPORTING_DATA: '/appctx',
  APP_UPDATES: '/api/v3/app_deployment_check',
};

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  public svc_host = '/no_svc_host';
  public licence_svc = '/no_licence_host';
  public deploy_svc = '/no_deployment_host';
  public core_svc = '/no_core_services';
  public shift_service = '/no_shift_service';
  public protocol = '';
  public data_services = '/no_flow_service';
  public factory_admin_host = '/no_factory_admin_host';

  constructor(@Inject('environment') public envVariables: any) {
    // console.log('Setting AuthModule CONST with ENV VAR');

    if (envVariables.protocol) {
      this.protocol = envVariables.protocol;
    }

    if (envVariables.service_host != null) {
      this.svc_host = envVariables.service_host;
    }
    if (envVariables.licence_services) {
      this.licence_svc = envVariables.licence_services;
    }
    if (envVariables.deploy_services) {
      this.deploy_svc = envVariables.deploy_services;
    }
    if (envVariables.deploy_services) {
      this.core_svc = envVariables.core_services;
    }
    if (envVariables.shift_service) {
      this.shift_service = envVariables.shift_service;
    }
    if (envVariables.data_services) {
      this.data_services = envVariables.data_services;
    }
    if (envVariables.factory_admin_host) this.factory_admin_host = envVariables.factory_admin_host;
  }

  getLicenceUrl(arg: keyof typeof MainServiceEndPoints) {
    return this.protocol + this.svc_host + this.licence_svc + MainServiceEndPoints[arg];
  }

  getCoreServiceUrl(arg: keyof typeof MainServiceEndPoints) {
    return this.protocol + this.svc_host + this.core_svc + MainServiceEndPoints[arg];
  }

  getAppUpdatesURL(arg: keyof typeof MainServiceEndPoints) {
    return this.protocol + this.factory_admin_host + MainServiceEndPoints[arg];
  }
}
